export const ACS_CONTACT_LINK_FR = 'https://www.acs-ami.com/fr/contactez-nous/';
export const ACS_CONTACT_LINK_EN = 'https://www.acs-ami.com/en/contact-us/';
export const ACS_WARRANTY_TABLE_LINK_FR = 'https://www.acs-ami.com/files/pdf/ACS-Expat-TOB-fr.pdf';
export const ACS_WARRANTY_TABLE_LINK_EN = 'https://www.acs-ami.com/files/pdf/ACS-Expat-TOB-en.pdf';
